<template lang="html">
    <div id="d-page-template-1">

        <section class="short-info-section-s1">
            <div class="box-top">
                <div class="col-12 col-title">
                <h2 class="txt-breadcrumb">
                    <span>Mi perfil</span>
                    Familia
                </h2>
                </div>
            </div>
        </section>
        <section class="requests-section">    
            <div class="box-results" v-if="!loading">
                <b-card no-body>
                    <b-card-text>
                        <div class="no-gutters post-template-s4" v-for="(v, vInx) in rows" :key="'vInx-'+vInx">
                            <div class="col-12 col-title">
                            <h5>{{v.name}}</h5>
                            </div>
        
                            <div class="col-sm col-time">
                            <h6>Parentesco</h6>
                            <h5>{{v.relationship}}</h5>
                            </div>
        
                            <div class="col-sm col-time">
                            <h6>Fecha de nacimiento</h6>
                            <h5>{{v.birthdate}}</h5>
                            </div>
        
                            <div class="col-sm col-time">
                            <h6>Dirección</h6>
                            <h5>{{v.address}}</h5>
                            </div>
                        </div>
                    </b-card-text>
                    
                </b-card>
            </div>
            <div class="box-results" v-else style="padding-top: 150px;text-align: center;">
                <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>
                
            </div>
        </section>
  
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        rows:{},  
        loading:false,
        
        

      }
    },
  
    methods: {
        getRows(){
            this.loading = true;
            axios.get(tools.url("/api/user/family")).then((response)=>{
                this.rows = response.data;
                this.loading = false;
            }).catch(()=>{
                this.modal.block = false;
                this.loading = false;
            });
        },
  
    },
  
    beforeMount(){
     
    },
  
    mounted() {
        this.getRows();
    },
  }
  </script>
  